///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.excel = abcsetup.excel || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.excel = {
    /**
     * Load the specified excel file into a multidimensional array
     *
     * @param {string} name
     * @param {function} callback
     * @param {boolean} read_empty_cells
     * @returns {array}
     */
    readFile(name, callback, read_empty_cells=false) {
        // Validate whether File is valid Excel file
        var regex = /^([a-zA-Z0-9()&#@^\s_\\.\-:])+(.xls|.xlsx|.csv)$/;
        if (regex.test(name.value.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();

                // For Browsers other than IE
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                        callback(abcsetup.excel.ProcessExcel(e.target.result, read_empty_cells));
                    };
                    reader.readAsBinaryString(name.files[0]);
                } else {
                    // For IE Browser
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        callback(abcsetup.excel.ProcessExcel(data, read_empty_cells));
                    };
                    reader.readAsArrayBuffer(name.files[0]);
                }
            } else {
                abcsetup.alerts.show("Error Loading Data", "This browser does not support HTML5.");
            }
        } else {
            abcsetup.alerts.show("Error Loading Data", "Please upload a valid Excel file.");
        }
    },


    /**
     * Process the specified excel data
     *
     * @param {*} data
     */
    ProcessExcel: function (data, read_empty_cells) {
        // Read the Excel File data
        var workbook = XLSX.read(data, {
            type: 'binary',
            cellDates: true,
        });

        if (typeof read_empty_cells !== 'undefined' && read_empty_cells === true) {
            read_empty_cells = true;
        }
        var sheet = workbook.Sheets[workbook.SheetNames[0]]; // get the first worksheet
        var range = XLSX.utils.decode_range(sheet['!ref']); // get the range
        var return_data = [];
        for(var R = range.s.r; R <= range.e.r; ++R) {
            for(var C = range.s.c; C <= range.e.c; ++C) {
                /* find the cell object */
                var cellref = XLSX.utils.encode_cell({c:C, r:R}); // construct A1 reference for cell
                var cellval = '';
                if (!sheet[cellref] && !read_empty_cells) { // Ignores empty cells
                    continue;
                } else if (sheet[cellref]) {
                    cellval = sheet[cellref].v;
                }

                return_data[C] = return_data[C] ?? [];
                return_data[C].push(cellval);
            }
        }

        return return_data;
    },

    /**
     * Convert data from readFile into an array
     *
     *
     * @param {*} data
     */
    toArray: function(data, column_map) {
        var i = 0,
            j = 0,
            column = '',
            arr = [],
            arr_index = 0;

        // Loop through the data to create rows as it is outputted by columnn
        for (i in data) {
            for (j=0; j < data[i].length; j++) {
                // Store newly found column
                if (j === 0) {
                    column = data[i][j];

                    if (typeof column_map !== 'undefined' && typeof column_map[i] !== 'undefined') {
                        column = column_map[i];
                    }
                    continue;
                }

                // Populate rows
                arr_index = j-1;

                if (typeof arr[arr_index] === 'undefined') {
                    arr[arr_index] = [];
                }

                arr[arr_index][column] = data[i][j];
            }
        }

        return arr;
    }
}
